module.exports = __webpack_public_path__ + "static/media/main-fr.47878590.webp";